<template>
  <div>

    <div class="m-wrapper" style="margin-top:18px;border-radius:0px;">
      <div class="titleBox">
          <span class="bigTitleInfo">Policy Analysis</span>
      </div>
      <div class="splitLine"></div>

      <div class="filter-wrapper">
        <div class="filter-content">
          <div class="filter clearfix">
            <div style="width: 100%" class="item">
              <div class="inner-wrapper">
                <div style="width: 108px" class="label">Policy</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.plcName"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                    @change="plcNameChange"
                  >
                    <el-option
                      v-for="item in plcNameDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
<!--                  <el-select v-model="form.plcName" placeholder="请输入政策名称" style="width: 100%" >-->
<!--                    <el-option-->
<!--                      v-for="item in plcNameDdb"-->
<!--                      :key="item.id"-->
<!--                      :label="item.val"-->
<!--                      :value="item.id">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
                </div>
<!--                <div style="width: 72px" class="label">政策查询</div>-->
<!--                <div class="form">-->
<!--                  <el-input-->
<!--                    prefix-icon="el-icon-search"-->
<!--                    size="small"-->
<!--                    placeholder="请输入政策名称"-->
<!--                    style="width: 100%"-->
<!--                    v-model="form.plcName"-->
<!--                  />-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 10px;" class="filter-content">
          <div class="filter clearfix">
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 108px" class="label">FTZ/Area</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.ftzName"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in ftzNameDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 140px;text-align: right;padding-right: 10px" class="label">Published</div>
                <div class="form frombox">
                  <el-select
                    filterable
                    v-model="form.releaseDateStart"
                    placeholder="from"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                    @change="releaseDateDdbFn"
                  >
                    <el-option
                      v-for="item in releaseDateDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <div class="line">-</div> 
                  <el-select
                    filterable
                    v-model="form.releaseDateEnd"
                    placeholder="to"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                    :disabled="form.releaseDateStart == ''"
                  >
                    <el-option
                      v-for="item in releaseDateDdbEnd"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px;" class="item">
              <div class="inner-wrapper">
                <div style="width: 108px" class="label">Policy level</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.plcRank"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in plcRankDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px;" class="item">
              <div class="inner-wrapper">
                <div style="width: 140px;text-align: right;padding-right: 10px" class="label">Sector</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.inds"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in indsDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-confirm">
          <div class="confirm-button" @click="changeTableData">
            Go
          </div>
        </div>
      </div>
      <div class="tablesy">
        <FtaTable
          ref="FtaTable"
          :tableData="tableData"
          :column="column"
          :pageable="true"
          @pageConfigs="pageConfigFn"
          :pageConfig="pageConfig"
          :diaLogShow="true"
          path="/policy/queryContentByPlcName/"
          parameter='plcName'
        />
      </div>
    </div>
  </div>
</template>

<script>
import FtaHeader from '../component/FtaHeader'
import request from '../../../ftaUtils/http'
import baseUrl from '../../../ftaUtils/baseUrl'
import FtaTable from '../component/FtaTable'
import ChartBar from '../component/__ChartBar'
import ChartLine from '../component/ChartLine'
import ChartPie from '../component/ChartPie'
import moment from 'moment'
import FtaTitle from '../component/FtaTitle'
import {getCookieKey} from '../../../ftaUtils/util'

export default {
  name: 'PolicyQuery',
  components: {
    FtaTitle,
    FtaHeader,
    FtaTable,
    ChartBar,
    ChartLine,
    ChartPie
  },
  data () {
    return {
      form: {
        plcName: '',
        ftzName: '',
        releaseDateStart: '',
        releaseDateEnd: '',
        plcRank: '',
        inds: ''
      },
      // 政策查询
      plcNameDdb: [],
      // departmentDdb: [],
      plcTypeDdb: [],
      // 所属区域
      ftzNameDdb: [],
      // 产业领域
      indsDdb: [],
      // 政策类型
      plcRankDdb: [],
      // 政策发布时间
      releaseDateDdb: [],
      releaseDateDdbEnd:[],
      releaseDateDdbArr:[],
      pageConfig: {
        // total: 10000,
        page: 1,
        pageSize: 10
      },
      tableData: [],
      column: [
        {prop: 'plcName', label: 'File name', align: 'left'},
        {prop: 'department', label: 'Authority', align: 'center'},
        {prop: 'releaseDate', label: 'Date', align: 'center'},
        {prop: 'plcRank', label: 'Policy level', align: 'center'},
        {prop: 'plcType', label: 'Policy category', align: 'center'},
        {prop: 'inds', label: 'Sector', align: 'center'},
        {prop: 'ftzName', label: 'FTZ/Area', align: 'center'}
      ]
    }
  },
  methods: {
    // 开始时间
    releaseDateDdbFn(value){
       if(value === 'all'){
         this.releaseDateDdbEnd = [...this.releaseDateDdbArr]
       }else{
        let arr = [...this.releaseDateDdbArr]
        let filterArr = arr.filter(res => { return res.val !== 'all' &&  Number(res.val) >= Number(value)})
        this.releaseDateDdbEnd = filterArr
       }
       this.form.releaseDateEnd = ''      
    },
    // 父组件的值
    pageConfigFn(val){
      this.pageConfig = val
      this.getQueryByPage()
    },
    plcNameChange () {
      this.pageConfig = {
        page: 1,
        pageSize: 10
      }
    },
    getQueryDdbInfo () {
      request('get', `${baseUrl.base_1}/policy/queryDdbInfo`).then((res) => {
        const {ftzNameDdb, indsDdb, plcRankDdb, releaseDateDdb, plcNameDdb} = res.data
        this.ftzNameDdb = ftzNameDdb.filter(item => {
          return item
        })
        this.plcNameDdb = plcNameDdb.filter(item => {
          return item
        })
        this.plcRankDdb = plcRankDdb.filter(item => {
          return item
        })
        this.releaseDateDdb = releaseDateDdb.filter(item => {
          return item
        })
        this.releaseDateDdbEnd = releaseDateDdb.filter(item => {
          return item
        })
        this.releaseDateDdbArr = releaseDateDdb.filter(item => {
          return item
        })
        this.indsDdb = indsDdb.filter(item => {
          return item
        })
        this.plcNameDdb.unshift({val: 'all', id: 'all'})
        this.ftzNameDdb.unshift({val: 'all', id: 'all'})
        this.indsDdb.unshift({val: 'all', id: 'all'})
        this.plcRankDdb.unshift({val: 'all', id: 'all'})
        this.releaseDateDdb.unshift({val: 'all', id: 'all'})
        this.releaseDateDdbEnd.unshift({val: 'all', id: 'all'})
        this.releaseDateDdbArr.unshift({val: 'all', id: 'all'})
      })
    },
    getQueryByPage () {
      let {page, pageSize} = this.pageConfig
      let formData = {...this.form}
      formData.plcName = formData.plcName == 'all' ? '': formData.plcName,
      formData.ftzName = formData.ftzName == 'all' ? '': formData.ftzName,
      formData.releaseDateStart = formData.releaseDateStart == 'all' ? '': formData.releaseDateStart,
      formData.releaseDateEnd = formData.releaseDateEnd == 'all' ? '': formData.releaseDateEnd,
      formData.plcRank = formData.plcRank == 'all' ? '': formData.plcRank,
      formData.inds = formData.inds == 'all' ? '': formData.inds,

      request('get', `${baseUrl.base_1}/policy/queryByPage`, {
        page: page, limit: pageSize, ...formData
      }).then((res) => {
        this.tableData = res.data.records
        // this.$refs.FtaTable.aa(this.tableData)
        this.tableData.forEach((item, index) => {
          item.num = index + 1
        })
        this.pageConfig.total = res.data.total
        this.pageConfig.pageSize = res.data.size
        this.pageConfig.page = res.data.current
        // console.log(res)
      })
    },
    changeTableData () {
      this.pageConfig.page = 1
      this.pageConfig.pageSize = 10
      this.getQueryByPage()
    }
  },
  created () {
    const TS02b1f2d3 = getCookieKey('TS02b1f2d3')
    this.$store.commit('ftaToken', TS02b1f2d3)

    this.getQueryDdbInfo()
    this.getQueryByPage()
  },
  // watch: {
  //   pageConfig: {
  //     handler () {
  //       this.getQueryByPage()
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="./PolicyQuery.less"  scoped></style>

